import React,{Component} from 'react'

class AIImage extends Component{
    render(){
        return(
            <div>
               <img src="./images/computer-office-image.png" height="50%"/>
            </div>
        )
    }
}

export default AIImage


// WEBPACK FOOTER //
// ./src/AIImage.js